// Dutch (source) → French translations for the UI. Strings not listed fall back
// to the Dutch text, so the app keeps working as translation grows.
export const FR = {
  // --- navigation / breadcrumbs ---
  'Prestaties': 'Performance',
  'Beheer': 'Gestion',
  'Verpakking': 'Emballages',

  // --- Data page: LightSpeed API card ---
  'LightSpeed API (automatisch)': 'API LightSpeed (automatique)',
  'Eenmalig verbinden; daarna haalt de app de verkopen zelf op — bij het openen van de app als de data ouder is dan 12 uur, of met de knop hieronder.':
    'Connexion unique ; ensuite l’app récupère les ventes elle-même — à l’ouverture de l’app si les données datent de plus de 12 h, ou via le bouton ci-dessous.',
  'De API-sleutel staat nog niet op de server (LIGHTSPEED_CLIENT_SECRET). Zet ze in de Coolify-omgeving en herstart.':
    'La clé API n’est pas encore sur le serveur (LIGHTSPEED_CLIENT_SECRET). Ajoutez-la dans l’environnement Coolify et redémarrez.',
  "Klik 'Verbind met LightSpeed' en meld aan met de LightSpeed-login van het café.":
    "Cliquez sur « Connecter LightSpeed » et connectez-vous avec le login LightSpeed du café.",
  'Je komt automatisch terug op deze pagina en de verbinding wordt afgerond.':
    'Vous revenez automatiquement sur cette page et la connexion est finalisée.',
  'Terugkeer-URL (moet zo geregistreerd staan op de LightSpeed API-client)':
    'URL de retour (doit être enregistrée telle quelle sur le client API LightSpeed)',
  'Kom je op een andere pagina terecht? Plak hier de volledige URL uit de adresbalk.':
    'Vous atterrissez sur une autre page ? Collez ici l’URL complète de la barre d’adresse.',
  'Verbinden…': 'Connexion…',
  'Verbind met LightSpeed': 'Connecter LightSpeed',
  'Bevestigen': 'Confirmer',
  'Verbonden!': 'Connecté !',
  'Verbonden': 'Connecté',
  'sinds': 'depuis',
  'Laatste API-sync': 'Dernière synchro API',
  'Gesynchroniseerd': 'Synchronisé',
  'Nu synchroniseren (laatste 3 dagen)': 'Synchroniser maintenant (3 derniers jours)',
  'LightSpeed ontkoppelen?': 'Déconnecter LightSpeed ?',
  'Ontkoppelen': 'Déconnecter',
  'Actie mislukt.': 'Action échouée.',

  // --- Verpakking (packaging stock & forecast) page ---
  'Voorraad en verbruiksprognose voor verpakkingsmateriaal — afgeleid uit de take-away-verkopen.':
    'Stock et prévision de consommation du matériel d’emballage — dérivés des ventes take-away.',
  'Take Away-info ontbreekt nog in de verkoopdata — de prognose telt voorlopig álle verkopen. Upload een recente transacties-export op de Data-pagina, daarna telt enkel take-away.':
    'L’info Take Away manque encore dans les données de vente — la prévision compte pour l’instant toutes les ventes. Chargez un export « transactions » récent sur la page Données ; ensuite seul le take-away comptera.',
  'Kies per product welke cup het verbruikt. Enkel take-away-verkopen tellen mee; de fractie per stuk staat normaal op 1.':
    'Choisissez par produit quelle cup il consomme. Seules les ventes take-away comptent ; la fraction par unité reste normalement à 1.',
  '— geen cup —': '— pas de cup —',
  'Toon inactieve items': 'Afficher les items inactifs',
  'Nog geen verpakkingsitems.': 'Pas encore d’items d’emballage.',
  'geschatte voorraad': 'stock estimé',
  'Komende 7 dagen': '7 prochains jours',
  'Komende 30 dagen': '30 prochains jours',
  'Laatste telling': 'Dernier comptage',
  'op': 'le',
  'geleverd': 'livré',
  'verbruikt': 'consommé',
  'Nog geen telling — voer een eerste voorraadtelling in.': 'Pas encore de comptage — encodez un premier inventaire.',
  'Voorraad op rond': 'Stock épuisé vers le',
  'Weekverbruik': 'Consommation hebdo',
  'gekoppelde producten': 'produits associés',
  'Telling': 'Comptage',
  'Levering': 'Livraison',
  'Correctie': 'Correction',
  'Voorraad bijwerken': 'Mettre à jour le stock',
  'Telling = absolute stand op het einde van die dag. Levering/correctie = verschil (+/−).':
    'Comptage = niveau absolu à la fin de cette journée. Livraison/correction = différence (+/−).',
  '— kies item —': '— choisir un item —',
  'Notitie (optioneel)': 'Note (optionnelle)',
  'Opslaan': 'Enregistrer',
  'Opgeslagen': 'Enregistré',
  'Type': 'Type',
  'Notitie': 'Note',
  'Nog geen bewegingen — start met een eerste telling.': 'Pas encore de mouvements — commencez par un premier comptage.',
  'Items beheren': 'Gérer les items',
  'Voeg verpakkingsitems toe of zet ze inactief.': 'Ajoutez des items d’emballage ou désactivez-les.',
  'Naam (bv. Cup Espresso)': 'Nom (p.ex. Cup Espresso)',
  'Groep (bv. boissons)': 'Groupe (p.ex. boissons)',
  'Toevoegen': 'Ajouter',
  'actief': 'actif',
  'inactief': 'inactif',
  'Koppeling producten ↔ verpakking': 'Association produits ↔ emballages',
  'per verkocht stuk': 'par unité vendue',
  'verkocht (120 d.)': 'vendus (120 j.)',
  'Verkoopdata tot': 'Données de vente jusqu’au',
  'Overzicht': 'Aperçu',
  'Drukte & Tijden': 'Affluence & Horaires',
  'Producten': 'Produits',
  'Samenstelling & Prijzen': 'Composition & Prix',
  'Productrelaties': 'Relations produits',
  'Productoverzicht': 'Catalogue',
  'Productkoppeling': 'Association produits',
  'Periode-rapport': 'Rapport période',
  'Productgroepen': 'Groupes de produits',
  // weekdays (backend sends Dutch names)
  'Maandag': 'Lundi', 'Dinsdag': 'Mardi', 'Woensdag': 'Mercredi', 'Donderdag': 'Jeudi',
  'Vrijdag': 'Vendredi', 'Zaterdag': 'Samedi', 'Zondag': 'Dimanche',
  'Zondag (uitzonderlijk open)': 'Dimanche (ouvert exceptionnellement)',
  'voormiddag': 'matin',
  // shared states
  'Er ging iets mis bij het laden.': 'Une erreur est survenue lors du chargement.',
  'Opnieuw proberen': 'Réessayer',
  'Geen gegevens voor deze periode.': 'Pas de données pour cette période.',
  'Categorieën': 'Catégories',
  'Tot nu toe dit jaar': 'Depuis le début de l’année',
  'vs vorige periode': 'vs période précédente',
  'vs eigen keuze': 'vs sélection',
  'Kassabonnen': 'Tickets de caisse',
  'Rapporten': 'Rapports',
  'Data': 'Données',
  'café analytics': 'café analytics',
  'Afmelden': 'Se déconnecter',

  // --- page titles (when different from the breadcrumb) ---
  'Samenstelling, prijzen & korting': 'Composition, prix & remises',
  'Databron & status': 'Source & état des données',

  // --- page subtitles ---
  'Kerncijfers van het café — omzet, bonnen en ontwikkeling.': 'Chiffres clés du café : CA, tickets et évolution.',
  'Wanneer is het druk of stil — per half uur, per dag, per dagdeel.': 'Quand est-ce animé ou calme : par demi-heure, par jour, par moment.',
  'Verkoopontwikkeling per productgroep over de hele periode (~1,5 jaar).': 'Évolution des ventes par groupe de produits sur toute la période (~1,5 an).',
  'Hoeveelheden en producten per bon, menuprijs-wijzigingen en de personeelskorting.': 'Quantités et produits par ticket, changements de prix menu et remise du personnel.',
  'Welke producten worden samen gekocht — netwerk van combinaties.': 'Quels produits sont achetés ensemble : le réseau des combinaisons.',
  'Alle producten in detail, gegroepeerd per categorie.': 'Tous les produits en détail, groupés par catégorie.',
  'Koppel producten over de systemen heen en beheer de categorieën.': 'Reliez les produits entre les systèmes et gérez les catégories.',
  'Gemiddelde per bon, aantal bonnen en wat samen besteld wordt.': 'Ticket moyen, nombre de tickets et ce qui est commandé ensemble.',
  'De volledige data-analyse als slide-rapport — bekijk online of download om te delen.': "L'analyse complète sous forme de rapport : à consulter en ligne ou à télécharger pour la partager.",

  // --- shared controls / common words ---
  'Laden...': 'Chargement...',
  'Stuks': 'Unités',
  'Omzet': 'CA',
  'Samen': 'Ensemble',
  'Vergelijk': 'Comparer',
  'per stuk': 'par unité',
  'Verloop (42 d.)': 'Évolution (42 j.)',
  'Voorraad': 'Stock',
  // --- Voorraadbeheer (inventory layers) ---
  'Voorraadbeheer': 'Gestion des stocks',
  'Voorraad en verbruiksprognose — verpakking uit de take-away-verkopen, ingrediënten uit alle verkopen.': 'Stock et prévision de consommation — emballages d’après les ventes à emporter, ingrédients d’après toutes les ventes.',
  'Ingrediënten': 'Ingrédients',
  'Ingrediënt toevoegen': 'Ajouter un ingrédient',
  'Verpakking toevoegen': 'Ajouter un emballage',
  'Nieuw ingrediënt': 'Nouvel ingrédient',
  'Nieuwe verpakking': 'Nouvel emballage',
  'Naam (bv. Koffiebonen, Havermelk)': 'Nom (p.ex. Café en grains, Lait d’avoine)',
  'Eenheid': 'Unité',
  'Annuleren': 'Annuler',
  'levering': 'livraison',
  'telling': 'inventaire',
  'voorraad': 'stock',
  'verbruik': 'consommation',
  'geen telling': 'pas d’inventaire',
  'geen telling — nog geen verloop': 'pas d’inventaire — pas encore d’historique',
  'op rond': 'épuisé vers le',
  'ingrediënt': 'ingrédient',
  'verpakking': 'emballage',
  'Nog geen ingrediënten — voeg er een toe en leg per product het recept vast.': 'Pas encore d’ingrédients — ajoutez-en un et définissez la recette par produit.',
  'Zet items actief of inactief (de historiek blijft bewaard).': 'Activez ou désactivez des articles (l’historique est conservé).',
  'Recepten: ingrediënten per product': 'Recettes : ingrédients par produit',
  'Per verkocht stuk — bv. 18 g koffiebonen en 150 ml melk voor een cappuccino. Alle verkopen tellen mee (ook eat-in).': 'Par unité vendue — p.ex. 18 g de café et 150 ml de lait pour un cappuccino. Toutes les ventes comptent (sur place aussi).',
  'Zoek een product om een recept toe te voegen…': 'Cherchez un produit pour ajouter une recette…',
  '+ ingrediënt': '+ ingrédient',
  'hoeveelheid': 'quantité',
  'Nog geen recepten — zoek een product hierboven.': 'Pas encore de recettes — cherchez un produit ci-dessus.',
  'Sync': 'Sync',
  'Synchroniseren…': 'Synchronisation…',
  'Sync mislukt': 'Échec de la synchronisation',
  'laatste sync': 'dernière synchro',
  'LightSpeed nu synchroniseren (sinds de vorige sync, min. 3 dagen; vult ontbrekende dagen aan)':
    'Synchroniser LightSpeed maintenant (depuis la dernière synchro, min. 3 jours ; complète les jours manquants)',
  'dag ontbreekt': 'jour manquant',
  'dagen ontbreken': 'jours manquants',
  'aangevuld': 'complété',
  'geen verkopen in LightSpeed': 'aucune vente dans LightSpeed',
  'Ontbrekende dagen (verwacht open, maar geen bonnen)': 'Jours manquants (ouverture attendue, mais aucun ticket)',
  'Deze dagen worden bij de volgende sync opnieuw opgehaald.': 'Ces jours seront récupérés à nouveau lors de la prochaine synchro.',
  'Periode': 'Période',
  'dagen': 'jours',
  'Nu synchroniseren': 'Synchroniser maintenant',
  'Maximaal 62 dagen per keer (langere periodes via de server-opdracht sync_lightspeed).':
    'Maximum 62 jours à la fois (périodes plus longues via la commande serveur sync_lightspeed).',
  'Startdatum ligt na de einddatum.': 'La date de début est postérieure à la date de fin.',
  'De standaardsync haalt minstens de laatste 3 dagen op, en verder terug tot de vorige geslaagde sync. Ontbrekende dagen worden automatisch mee opgehaald.':
    'La synchro standard récupère au moins les 3 derniers jours, et remonte jusqu’à la dernière synchro réussie. Les jours manquants sont récupérés automatiquement.',
  'periode': 'période',
  'niets nieuws': 'rien de nouveau',
  'vandaag': 'aujourd’hui',
  'gisteren': 'hier',
  'laatste': 'derniers',
  'LightSpeed nu synchroniseren (laatste 3 dagen)': 'Synchroniser LightSpeed maintenant (3 derniers jours)',
  'kassa-items met dezelfde naam, samengeteld': 'articles de caisse portant le même nom, additionnés',
  // --- nav restructure 2026-08 ---
  'Prijzen & korting': 'Prix & remises',
  'Menuprijs-wijzigingen op de kaart en de personeelskorting.': 'Modifications des prix de la carte et remise du personnel.',
  'Wanneer is het druk of stil — per half uur, per uur en per weekdag, plus de recorddagen.': 'Quand est-ce calme ou animé — par demi-heure, par heure et par jour de semaine, plus les jours records.',
  'Hoe ziet een bon eruit — waarde, samenstelling, drank mét eten en betaalwijze.': 'À quoi ressemble un ticket — valeur, composition, boisson avec repas et mode de paiement.',
  'Verkoop per hoofdcategorie (incl. btw, na korting) — zoals in LightSpeed · t.o.v. de vergelijkingsperiode': 'Ventes par catégorie principale (TVA comprise, après remise) — comme dans LightSpeed · vs la période de comparaison',
  // --- Productgroepen: all-products overview ---
  'Alle producten': 'Tous les produits',
  'Alle producten met hun verkoop t.o.v. een benchmarkperiode, en de ontwikkeling per productgroep.': 'Tous les produits avec leurs ventes par rapport à une période de référence, et l’évolution par groupe de produits.',
  'Per groep': 'Par groupe',
  'Lijst': 'Liste',
  'vs periode ervoor': 'vs période précédente',
  'periode ervoor': 'période précédente',
  'Klik op een groep voor de detailweergave, op een product voor zijn verloop.': 'Cliquez sur un groupe pour le détail, sur un produit pour son évolution.',
  'verschil met de benchmark': 'écart par rapport à la référence',
  'in de benchmark': 'dans la période de référence',
  'Benchmark': 'Référence',
  'slechts': 'seulement',
  'gedekt door data': 'couvert par les données',
  'volledig gedekt door data': 'entièrement couverte par les données',
  'detail': 'détail',
  'niet meer verkocht': 'plus vendu',
  'Koffie (overige)': 'Café — autres',
  'Dranken (overige)': 'Boissons — autres',
  'Voeding (overige)': 'Alimentation — autres',
  'Café (overige)': 'Café — autres consommations',
  'Overige': 'Autres',
  'Bekijk': 'Voir',
  'Download': 'Télécharger',
  'wis selectie': 'effacer la sélection',
  'Geselecteerd:': 'Sélection :',
  'Kopieer link': 'Copier le lien',
  'Gekopieerd': 'Copié',

  // --- date-range presets ---
  'Vandaag': 'Aujourd’hui',
  'Gisteren': 'Hier',
  'Deze maand': 'Ce mois-ci',
  'Dit jaar': 'Cette année',
  '3 mnd': '3 mois',
  '6 mnd': '6 mois',
  '1 jaar': '1 an',
  '1,5 jaar': '1,5 an',
  'Alles': 'Tout',
  'Aangepast': 'Personnalisé',
  'van': 'du',
  'tot': 'au',

  // --- Overzicht: comparison against an average day + receipts drill-down ---
  'Gemiddelde dag': 'Journée moyenne',
  'Gemiddelde weekdag': 'Jour de semaine moyen',
  'vs een normale dag': 'vs une journée normale',
  'vs': 'vs',
  'op een normale dag': 'sur une journée normale',
  'vs de hele dag': 'vs la journée entière',
  'om': 'à',
  'hele dag': 'journée entière',
  'Verloop van de dag': 'Déroulé de la journée',
  'omzet opgeteld per uur': 'chiffre d’affaires cumulé par heure',
  'omzet per uur': 'chiffre d’affaires par heure',
  'grijze stippellijn': 'ligne pointillée grise',
  'een normale dag': 'une journée normale',
  'de vergelijkingsperiode': 'la période de comparaison',
  'Opgeteld': 'Cumulé',
  'Per uur': 'Par heure',
  'Normale dag': 'Journée normale',
  'uitzonderlijke dag niet meegeteld': 'jour exceptionnel non compté',
  'uitzonderlijke dagen niet meegeteld': 'jours exceptionnels non comptés',
  'vs een normale dag dit jaar': 'vs une journée normale cette année',
  'Gemiddeld dit jaar': 'Moyenne cette année',
  'gemiddelde van de': 'moyenne des',
  'dit jaar': 'cette année',
  'gemiddelde per weekdag over': 'moyenne par jour de semaine sur',
  'open dagen dit jaar': 'jours d’ouverture cette année',
  'normaal': 'normale',
  'vergeleken met het': 'comparé à la',
  'gemiddelde van de laatste': 'moyenne des',
  'gemiddelde per weekdag van de laatste': 'moyenne par jour de semaine des',
  'weken': 'dernières semaines',
  'Grijze stippellijn = een normale dag van die weekdag':
    'Ligne pointillée grise = une journée normale de ce jour de semaine',
  'bekijk de bonnen': 'voir les tickets',
  'tik voor de bonnen met korting': 'touchez pour les tickets avec remise',
  'tik een dag voor de bonnen': 'touchez un jour pour voir les tickets',
  'Nog geen bonnen vandaag. De cijfers verversen automatisch zodra er verkocht wordt.':
    'Pas encore de tickets aujourd’hui. Les chiffres se rafraîchissent automatiquement dès la première vente.',
  'Geen bonnen op deze dag — het café was gesloten.':
    'Aucun ticket ce jour-là — le café était fermé.',
  'Data verversen…': 'Actualisation des données…',

  // --- receipts modal ---
  'Gem. per bon': 'Moy. par ticket',
  'Zoek op item, tafel of personeel': 'Rechercher un article, une table ou un employé',
  'Met korting': 'Avec remise',
  'Tijd': 'Heure',
  'artikel': 'article',
  '(geen items)': '(aucun article)',
  'Geen bonnen die aan de filter voldoen.': 'Aucun ticket ne correspond au filtre.',
  'Nog geen bonnen in deze periode.': 'Pas encore de tickets sur cette période.',
  'Alleen de meest recente bonnen worden getoond; de totalen hierboven dekken de hele periode.':
    'Seuls les tickets les plus récents sont affichés ; les totaux ci-dessus couvrent toute la période.',

  // --- Voorraadbeheer: bestellijst + aanvullingen ---
  'Te bestellen': 'À commander',
  'Hoeveel en tegen wanneer, zodat de levering er is vóór de voorraad op is.':
    'Combien et pour quand, afin que la livraison arrive avant la rupture de stock.',
  'geen leverancier ingesteld': 'aucun fournisseur défini',
  'Kopieer lijst': 'Copier la liste',
  'per doos': 'par boîte',
  'nodig': 'nécessaires',
  'nu bestellen — voorraad is op': 'commander maintenant — stock épuisé',
  'bestel vóór': 'commander avant',
  'nu bestellen': 'commander maintenant',
  'bestellen': 'à commander',
  'Nog aan te vullen': 'Encore à compléter',
  'Nog nooit geteld — zonder telling is er geen voorraad en dus geen advies':
    'Jamais compté — sans comptage, pas de stock et donc pas de conseil',
  'Geen producten gekoppeld — koppel producten of zet het item op inactief':
    'Aucun produit lié — liez des produits ou passez l’article en inactif',
  'Zet op inactief': 'Passer en inactif',
  'Verbruik': 'Consommation',
  'week': 'sem.',
  'dag': 'jour',
  'per week': 'par semaine',
  'per open dag': 'par jour d’ouverture',
  'gemiddeld over 8 weken': 'moyenne sur 8 semaines',
  'open dagen geteld': 'jours d’ouverture comptés',
  'dozen per week': 'boîtes par semaine',
  'Op een normale dag': 'Sur une journée normale',
  'Verloop': 'Évolution',
  'Verbruik per weekdag, per week en uitschieters': 'Consommation par jour, par semaine et pics',
  'tel opnieuw': 'recomptez',
  'open in 8 weken': 'ouvert sur 8 semaines',
  'stel een doosgrootte in bij Items beheren': 'définissez une taille de boîte dans Gérer les articles',
  'Voorraad staat negatief — de telling klopt niet meer of een levering is niet ingeboekt; tel opnieuw':
    'Stock négatif — le comptage n’est plus juste ou une livraison n’a pas été saisie ; recomptez',
  'Per week — afwijking t.o.v. een normale week': 'Par semaine — écart vs une semaine normale',
  'Dagen die afweken': 'Jours atypiques',
  'i.p.v.': 'au lieu de',
  'Geen uitschieters — het verbruik volgt het gewone weekpatroon.':
    'Aucun pic — la consommation suit le rythme habituel de la semaine.',
  'Dit item niet meer opvolgen?': 'Ne plus suivre cet article ?',
  'Telling ouder dan zes weken — de schatting loopt weg van de werkelijkheid':
    'Comptage vieux de plus de six semaines — l’estimation s’éloigne de la réalité',
  'Leverancier': 'Fournisseur',
  'leverancier': 'fournisseur',
  'Per doos': 'Par boîte',
  'Levertijd': 'Délai',
  'Voorraad voor': 'Stock pour',
  'Leverancier, doosgrootte, levertijd en gewenste voorraad — samen bepalen ze wat er op de bestellijst komt.':
    'Fournisseur, taille de boîte, délai et stock souhaité — ensemble ils déterminent la liste de commande.',
  'Levertijd = dagen tussen bestellen en leveren. Voorraad voor = hoeveel dagen verbruik je in huis wil houden ná levering.':
    'Délai = jours entre la commande et la livraison. Stock pour = combien de jours de consommation garder après la livraison.',

  // --- product timing (Wanneer verkopen we dit?) ---
  'Wanneer verkopen we dit?': 'Quand le vendons-nous ?',
  'Verkoopt vooral in de': 'Se vend surtout en',
  'van de verkopen tegenover': 'des ventes contre',
  'voor het café als geheel': 'pour le café dans son ensemble',
  'Volgt ongeveer het ritme van het café.': 'Suit à peu près le rythme du café.',
  'Per dagdeel': 'Par moment de la journée',
  'Per weekdag': 'Par jour de semaine',
  'deze selectie': 'cette sélection',
  'het café': 'le café',
  'café': 'café',
  'Namiddag (vanaf 14:30)': 'Après-midi (à partir de 14:30)',

  // --- revenue groups (Omzetgroepen) ---
  'Omzetgroepen': 'Groupes de revenus',
  'Verkoop per hoofdcategorie (bedrag incl. btw, na korting) — zoals in LightSpeed.':
    'Ventes par catégorie principale (montant TVA comprise, après remise) — comme dans LightSpeed.',
  'Omzetgroep': 'Groupe de revenus',
  'Aandeel': 'Part',
  'Bedrag': 'Montant',
  'Netto (excl. btw)': 'Net (hors TVA)',
  'Bonnen': 'Tickets',
  'bon': 'ticket',
  'Totaal': 'Total',
  'Bonnen per groep telt elke bon met minstens één artikel uit die groep, dus de som ligt hoger dan het totaal aantal bonnen (een bon bevat vaak meerdere groepen).':
    'Le nombre de tickets par groupe compte chaque ticket contenant au moins un article de ce groupe ; la somme dépasse donc le total des tickets (un ticket contient souvent plusieurs groupes).',
  'Dranken': 'Boissons',
  'Keuken': 'Cuisine',
  'Diversen': 'Divers',
  'IJs': 'Glaces',
  'Bouillons': 'Bouillons',

  // --- page UI strings (merged from translation pass) ---
  "Data t/m": "Données jusqu'au",
  "Omzet (periode)": "CA (période)",
  "Gemiddeld per bon": "Moyenne par ticket",
  "bonnen": "tickets",
  "Bonnen per dag": "Tickets par jour",
  "open dagen": "jours d'ouverture",
  "gemiddeld per open dag": "moyenne par jour d'ouverture",
  "Omzet & bonnen per maand": "CA & tickets par mois",
  "Omzet & bonnen per week": "CA & tickets par semaine",
  "Ontwikkeling over de periode": "Évolution sur la période",
  "Maand": "Mois",
  "Week": "Semaine",
  "vs vorig jaar": "vs an dernier",
  "Omzet vorig jaar": "CA an dernier",
  "Stippellijn = zelfde periode vorig jaar": "Pointillé = même période l'an dernier",
  "Vergelijking met vorig jaar op het deel van de periode waarvoor toen ook data bestaat": "Comparaison avec l'an dernier sur la partie de la période également couverte par les données",
  "Dagdeel-omzet": "CA par moment de la journée",
  "Laatste 6 maanden": "6 derniers mois",
  "Groei t.o.v. vorig jaar": "Croissance par rapport à l'an dernier",
  "Volledige maanden in beide jaren · café-omzet · totaal": "Mois complets sur les deux années · CA café · total",
  "Per maand (€)": "Par mois (€)",
  "Vergelijk altijd met dezelfde maand vorig jaar (YoY) — niet met de vorige maand; een café leeft op seizoenen.": "Comparez toujours avec le même mois l'an dernier (YoY) — pas avec le mois précédent ; un café vit au rythme des saisons.",
  "Waar komt de groei vandaan? Volume vs prijs": "D'où vient la croissance ? Volume vs prix",
  "Artikelen per bon": "Articles par ticket",
  "Prijs per artikel": "Prix par article",
  "Omzetgroei = meer bonnen × artikelen per bon × prijs per artikel. Zo zie je meteen wélke van de drie beweegt.": "Croissance du CA = plus de tickets × articles par ticket × prix par article. Vous voyez ainsi tout de suite lequel des trois bouge.",
  "Prijspeil van de vaste toppers": "Niveau de prix des incontournables",
  "Item": "Article",
  "prijs": "prix",
  "volume": "volume",
  "Gemiddelde omzet per weekdag": "CA moyen par jour de la semaine",
  "Hele dataset · zondag gesloten": "Ensemble des données · fermé le dimanche",
  "Gem. omzet": "CA moyen",
  "Drukste dag": "Jour le plus animé",
  "Stilste dag": "Jour le plus calme",
  "Drukste halve dag": "Demi-journée la plus animée",
  "Gem. bonnen/dag": "Tickets moyens/jour",
  "hele dataset": "ensemble des données",
  "Drukte per half uur (gem. bonnen)": "Affluence par demi-heure (tickets moyens)",
  "Per weekdag · Europe/Brussels — lichte cellen = stil/leeg": "Par jour de la semaine · Europe/Bruxelles — cellules claires = calme/vide",
  "Gemiddelde drukte per half uur": "Affluence moyenne par demi-heure",
  "Over alle open dagen": "Sur tous les jours d'ouverture",
  "Gem. bonnen": "Tickets moyens",
  "Omzet per dagdeel": "CA par moment de la journée",
  "Gemiddelde bon (AOV) per uur": "Ticket moyen (AOV) par heure",
  "Lunchuren = hoge bon (volledige maaltijden), koffiemomenten = lage bon": "Heures du midi = ticket élevé (repas complets), pauses café = ticket bas",
  "Gem. bon": "Ticket moyen",
  "Basket per weekdag": "Panier par jour de la semaine",
  "Artikelen per bon (staven) en prijs per artikel (lijn) — het weekend koopt méér, niet duurder": "Articles par ticket (barres) et prix par article (ligne) — le week-end on achète plus, pas plus cher",
  "Artikelen/bon": "Articles/ticket",
  "€/artikel": "€/article",
  "Populairste product per uur × weekdag": "Produit le plus populaire par heure × jour de la semaine",
  "Cappuccino in de ochtend, Vegetable Plate rond de lunch, koffie + zoet in de namiddag": "Cappuccino le matin, Vegetable Plate autour du midi, café + douceur l'après-midi",
  "overige": "autres",
  "Feestdagen & uitzonderlijke openingen": "Jours fériés & ouvertures exceptionnelles",
  "Dagen dat het café open was op een zondag of feestdag (de meeste feestdagen is het gesloten)": "Jours où le café était ouvert un dimanche ou un jour férié (la plupart des jours fériés, il est fermé)",
  "Datum": "Date",
  "Dag": "Jour",
  "vs gem. dag": "vs jour moyen",
  "Nog geen uitzonderlijke openingsdagen in de data.": "Pas encore de jours d'ouverture exceptionnels dans les données.",
  "Laden…": "Chargement…",
  "Kon data niet laden": "Impossible de charger les données",
  "Is de backend bereikbaar?": "Le backend est-il accessible ?",
  "ochtend": "matin",
  "middag": "midi",
  "namiddag": "après-midi",
  "avond": "soir",
  "nieuw": "nouveau",
  "Koekjes": "Biscuits",
  "Ontbijt": "Petit-déjeuner",
  "Gebak": "Pâtisseries",
  "Hartige lunch": "Lunch salé",
  "Koffie (totaal)": "Café (total)",
  "Matcha + Genmaicha": "Matcha + Genmaicha",
  "Overige dranken": "Autres boissons",
  "Thee": "Thé",
  "Voeding": "Alimentation",
  "Kies producten / categorieën": "Choisir produits / catégories",
  "zoek…": "rechercher…",
  "categorie": "catégorie",
  "subcategorie": "sous-catégorie",
  "Niets gevonden.": "Aucun résultat.",
  "Verkochte stuks": "Unités vendues",
  "geselecteerd": "sélectionné(s)",
  "Omzet (incl. btw)": "CA (TVA incl.)",
  "eigen selectie": "sélection perso",
  "Gem. prijs per stuk": "Prix moyen par unité",
  "over de selectie": "sur la sélection",
  "Ontwikkeling — eigen selectie (samen)": "Évolution — sélection perso (ensemble)",
  "trend": "tendance",
  "Vergelijking — per selectie": "Comparaison — par sélection",
  "Elke lijn = één product/categorie": "Chaque ligne = un produit/catégorie",
  "Selectie": "Sélection",
  "€/stuk": "€/unité",
  "Producten in groep": "Produits dans le groupe",
  "Ontwikkeling": "Évolution",
  "Per maand": "Par mois",
  "Kerncijfers van deze groep": "Chiffres clés de ce groupe",
  "Jaar-op-jaar =": "Année sur année =",
  "vs dezelfde maanden vorig jaar — de eerlijkste vergelijking (filtert seizoen weg)": "vs les mêmes mois l'an dernier — la comparaison la plus juste (neutralise la saison)",
  "Op % van de bonnen": "Sur % des tickets",
  "afgelopen jaar": "année écoulée",
  "Prijs per stuk": "Prix par unité",
  "gemiddeld": "moyen",
  "Aandeel café-omzet": "Part du CA café",
  "Sterkste dag": "Jour le plus fort",
  "stuks/dag": "unités/jour",
  "Binnen de groep: wat werkt?": "Dans le groupe : qu'est-ce qui marche ?",
  "YoY": "AsA",
  "Producten in deze groep": "Produits dans ce groupe",
  "producten": "produits",
  "Geen producten gevonden.": "Aucun produit trouvé.",
  "Best verkochte voedingsproducten": "Produits alimentaires les plus vendus",
  "Op aantal stuks": "Par nombre d'unités",
  "Op omzet": "Par CA",
  "st.": "u.",
  "afgelopen periode": "période écoulée",
  "Mediaan per bon": "Médiane par ticket",
  "de helft van de bonnen zit eronder": "la moitié des tickets est en dessous",
  "Drank mét eten": "Boisson avec repas",
  "enkel drank": "boisson seule",
  "Drank + eten": "Boisson + repas",
  "Enkel drank": "Boisson seule",
  "Enkel eten": "Repas seul",
  "Anders": "Autre",
  "Gemiddelde per bon & bonnen/dag per maand": "Moyenne par ticket et tickets/jour par mois",
  "Gemiddelde per bon & bonnen/dag per week": "Moyenne par ticket et tickets/jour par semaine",
  "Gem./bon vorig jaar": "Moy./ticket an dernier",
  "Gem./bon": "Moy./ticket",
  "Bonnen/dag": "Tickets/jour",
  "Spreiding van de bonwaarde": "Répartition de la valeur des tickets",
  "mediaan": "médiane",
  "gemiddelde": "moyenne",
  "van de bonnen is ≤ €5": "des tickets sont ≤ 5 €",
  "Het gemiddelde ligt boven de mediaan: veel kleine koffiebonnen, opgetild door grotere (groeps)lunches.": "La moyenne est supérieure à la médiane : beaucoup de petits tickets café, tirés vers le haut par de plus gros déjeuners (de groupe).",
  "van de bonnen is groter dan €25.": "des tickets dépassent 25 €.",
  "Recorddagen": "Jours record",
  "Meeste bonnen en hoogste café-omzet in de periode": "Plus de tickets et plus haut CA café sur la période",
  "Meeste bonnen": "Plus de tickets",
  "Hoogste omzet": "CA le plus élevé",
  "Vaakst samen besteld": "Le plus souvent commandés ensemble",
  "top-combinaties over": "top combinaisons sur",
  "Combinatie": "Combinaison",
  "Lift": "Lift",
  "= hoe veel vaker twee producten sámen op een bon staan dan toeval zou verklaren. Lift 11 = 11× vaker dan toeval; rond 1 = geen verband.": "= combien de fois plus souvent deux produits figurent ensemble sur un ticket que le hasard ne l'expliquerait. Lift 11 = 11× plus souvent que le hasard ; autour de 1 = aucun lien.",
  "De gemiddelde bestelling": "La commande moyenne",
  "artikelen": "articles",
  "per bon": "par ticket",
  "Wat zit er in een bon?": "Qu'y a-t-il dans un ticket ?",
  "Favoriete producten": "Produits favoris",
  "Worden drankjes met eten gecombineerd?": "Les boissons sont-elles combinées avec un repas ?",
  "bonnen met een drankje": "tickets avec une boisson",
  "Van alle bonnen met een drankje wordt": "Sur tous les tickets avec une boisson,",
  "samen met eten besteld, en": "sont commandés avec un repas, et",
  "apart.": "séparément.",
  "Betaalmethodes": "Moyens de paiement",
  "Aandeel van de omzet": "Part du CA",
  "Geen betaalgegevens in deze periode.": "Aucune donnée de paiement sur cette période.",
  "hoeveelheden meegeteld": "quantités comprises",
  "Verschillende producten/bon": "Produits différents/ticket",
  "unieke producten": "produits uniques",
  "Bonnen met een dubbel": "Tickets avec un doublon",
  "2+ van hetzelfde": "2+ du même",
  "Artikelen laatste maand": "Articles le mois dernier",
  "totaal verkocht": "total vendu",
  "Samenstelling per bon — evolutie": "Composition par ticket — évolution",
  "Artikelen (hoeveelheden) & verschillende producten zijn robuust; bonregels springen bij de kassa-overstap (mrt 2026) door een andere registratie, geen gedragswijziging": "Les articles (quantités) et les produits différents sont robustes ; les lignes de ticket sautent lors du changement de caisse (mars 2026) à cause d'un autre enregistrement, pas d'un changement de comportement",
  "Versch. producten/bon": "Produits diff./ticket",
  "Bonregels/bon": "Lignes de ticket/ticket",
  "Artikelen per bon:": "Articles par ticket :",
  "Dat artikelen > producten bevestigt dat hoeveelheden correct worden meegeteld (2× cappuccino = 2 artikelen, 1 product).": "Le fait qu'articles > produits confirme que les quantités sont bien comptées (2× cappuccino = 2 articles, 1 produit).",
  "Menuprijs-wijzigingen": "Changements de prix au menu",
  "gevolgde producten wijzigden van prijs": "produits suivis ont changé de prix",
  "stabiel": "stables",
  "Prijsstijgingen": "Hausses de prix",
  "Product": "Produit",
  "was": "avant",
  "nu": "maintenant",
  "Prijsdalingen": "Baisses de prix",
  "Geen noemenswaardige dalingen.": "Aucune baisse notable.",
  "Op": "Sur",
  "menuprijs": "prix au menu",
  "(kaartprijs); zo tonen mix-effecten (gratis bolletjes, combo's) of kortingen zich niet als nep-prijswijziging. De cappuccino ging in april 2026 van € 4,00 naar € 4,20.": "(prix carte) ; ainsi les effets de mix (boules gratuites, combos) ou les remises n'apparaissent pas comme de faux changements de prix. Le cappuccino est passé en avril 2026 de 4,00 € à 4,20 €.",
  "Personeelskorting (≈50%)": "Remise du personnel (≈50%)",
  "De dominante kortingstier is 50% — de personeelskorting. Sinds de LightSpeed-kassa (mrt 2026) te volgen.": "Le palier de remise dominant est 50% — la remise du personnel. Suivable depuis la caisse LightSpeed (mars 2026).",
  "Personeelsbonnen": "Tickets du personnel",
  "bestellingen": "commandes",
  "Toegekende korting": "Remise accordée",
  "subsidie": "subvention",
  "Effectief betaald": "Effectivement payé",
  "bruto": "brut",
  "Gem. korting": "Remise moy.",
  "bevestigt de 50%-tier": "confirme le palier de 50%",
  "Korting (€)": "Remise (€)",
  "Meest met personeelskorting": "Le plus avec remise du personnel",
  "korting": "remise",
  "Daarnaast: losse promokortingen": "En plus : remises promo ponctuelles",
  "regels": "lignes",
  "en grote bon/voucher-correcties": "et grosses corrections ticket/bon d'achat",
  "apart gehouden zodat de cijfers zuiver blijven. Onder Odoo werd korting nauwelijks geregistreerd.": "tenues à part pour que les chiffres restent propres. Sous Odoo, la remise était à peine enregistrée.",
  "Geen kortinggegevens in deze periode.": "Aucune donnée de remise sur cette période.",
  "Gem. prijs": "Prix moy.",
  "Naam": "Nom",
  "Producten verkocht": "Produits vendus",
  "Totale omzet": "CA total",
  "Zoek product of subcategorie…": "Rechercher un produit ou une sous-catégorie…",
  "st": "u",
  "Subcat.": "Sous-cat.",
  "% omzet": "% CA",
  "Laatst verkocht": "Vendu en dernier",
  "Bonnen geanalyseerd": "Tickets analysés",
  "met ≥1 product": "avec ≥1 produit",
  "Producten (knopen)": "Produits (nœuds)",
  "meest verkocht": "les plus vendus",
  "Combinaties (lijnen)": "Combinaisons (lignes)",
  "samen": "ensemble",
  "Sterkste duo": "Duo le plus fort",
  "Netwerk — samen gekocht": "Réseau — achetés ensemble",
  "Bol = product (grootte = hoe vaak verkocht) · lijn = samen gekocht (dikte = sterkte). Beweeg over een bol om de relaties te zien.": "Bulle = produit (taille = fréquence des ventes) · ligne = achetés ensemble (épaisseur = force). Passe sur une bulle pour voir les relations.",
  "Aantal": "Nombre",
  "min. samen": "min. ensemble",
  "Sterkste combinaties": "Combinaisons les plus fortes",
  "Relaties van": "Relations de",
  "Top 10 · vaakst samen gekocht": "Top 10 · le plus souvent achetés ensemble",
  "= hoe veel vaker dan toeval. Lift 11 = 11× vaker samen dan je puur op kans zou verwachten; rond 1 = geen verband.": "= combien de fois plus que le hasard. Lift 11 = 11× plus souvent ensemble que ce que le hasard prédirait ; autour de 1 = aucun lien.",
  "LightSpeed-export uploaden": "Importer un export LightSpeed",
  "Sleep een 'transacties' CSV/XLSX hierheen — data wordt direct toegevoegd": "Glisse un CSV/XLSX de « transactions » ici — les données sont ajoutées direct",
  "Bezig met importeren…": "Import en cours…",
  "Klik of sleep een bestand (.csv / .xlsx)": "Clique ou glisse un fichier (.csv / .xlsx)",
  "geïmporteerd": "importé",
  "Upload mislukt.": "Échec de l'import.",
  "Bonregels": "Lignes de ticket",
  "Betalingen": "Paiements",
  "Dataperiode & bronnen": "Période & sources des données",
  "historiek tot de overstap naar LightSpeed (~mrt 2026)": "historique jusqu'au passage à LightSpeed (~mars 2026)",
  "via Excel-import / API (in opbouw).": "via import Excel / API (en construction).",
  "Laatste sync": "Dernière synchronisation",
  "ok": "ok",
  "fout": "erreur",
  "Productgroepen (definities)": "Groupes de produits (définitions)",
  "Welke producten elke rapportgroep voedt — zo blijft het transparant": "Quels produits alimentent chaque groupe de rapport — pour rester transparent",
  "Producten totaal": "Total produits",
  "Gekoppeld": "Reliés",
  "Categorie overschreven": "Catégorie remplacée",
  "Zoek product…": "Cherche un produit…",
  "Nog te doen": "À faire",
  "Alle": "Tous",
  "Effectieve categorie": "Catégorie effective",
  "Koppel aan Odoo-product": "Relier à un produit Odoo",
  "Of: stel categorie in": "Ou : définis la catégorie",
  "Eerste 400 van": "Les 400 premiers sur",
  "verfijn met zoeken.": "affine avec la recherche.",
  "eigen": "propre",
  "zoek Odoo-product…": "cherche un produit Odoo…",
  "Voorstel": "Suggestion",
  "(geen sub)": "(pas de sous)",
  "Wissen": "Effacer",
  "Categorieën beheren": "Gérer les catégories",
  "Hernoem of voeg een (bron)categorie samen met een andere. Geldt overal: catalogus, grafieken en rapportgroepen.": "Renomme une catégorie (source) ou fusionne-la avec une autre. Vaut partout : catalogue, graphiques et groupes de rapport.",
  "Broncategorie": "Catégorie source",
  "Bron": "Source",
  "Toewijzen aan": "Attribuer à",
  "(laat staan)": "(laisser tel quel)",
  "Toewijzing wissen": "Effacer l'attribution",
  "E-mailadres": "E-mail",
  "Versturen…": "Envoi…",
  "Stuur inlogcode": "Envoyer le code",
  "We stuurden een 6-cijferige code naar": "On a envoyé un code à 6 chiffres à",
  "Dev-modus — je code is": "Mode dev — ton code est",
  "Controleren…": "Vérification…",
  "Inloggen": "Se connecter",
  "ander e-mailadres": "autre e-mail",
  "Versturen mislukt. Probeer opnieuw.": "Échec de l'envoi. Réessaie.",
  "Verkeerde code.": "Code incorrect.",

  // --- Rapport page (flexible period report) ---
  "Kwartaal": "Trimestre",
  "Jaar": "Année",
  "Vorig jaar": "An dernier",
  "Vorige periode": "Période précédente",
  "Andere periode": "Autre période",
  "Afdrukken": "Imprimer",
  "vergeleken met": "comparé à",
  "Kies een periode (en eventueel een vergelijkingsperiode).": "Choisissez une période (et éventuellement une période de comparaison).",
  "Omzet per open dag": "CA par jour d'ouverture",
  "toen": "avant",
  "Omzet per week": "CA par semaine",
  "Omzet per dag": "CA par jour",
  "Vergelijking": "Comparaison",
  "Grijze stippellijn = vergelijkingsperiode (op volgorde gelegd)": "Pointillé gris = période de comparaison (alignée dans l'ordre)",
  "t.o.v. de vergelijkingsperiode": "par rapport à la période de comparaison",
  "Groep": "Groupe",
  "Dagdelen & weekdagen": "Moments de la journée & jours de semaine",
  "gemiddelde omzet per open dag": "CA moyen par jour d'ouverture",
  "Weekdag": "Jour",
  "Nu": "Actuel",
  "Grootste stijgers": "Plus fortes hausses",
  "Grootste dalers": "Plus fortes baisses",
  "omzetverschil in € t.o.v. de vergelijkingsperiode": "écart de CA en € vs la période de comparaison",
  "Geen noemenswaardige verschuivingen.": "Pas d'évolutions notables.",
  "Dag per dag": "Jour par jour",
  "vlag = afwijking van ±20% t.o.v. dezelfde weekdag in de vergelijkingsperiode": "signal = écart de ±20% vs le même jour de semaine dans la période de comparaison",
  "vs verwacht": "vs attendu",
  "januari": "janvier", "februari": "février", "maart": "mars", "april": "avril",
  "mei": "mai", "juni": "juin", "juli": "juillet", "augustus": "août",
  "september": "septembre", "oktober": "octobre", "november": "novembre", "december": "décembre",
  "Ochtend (08:30–12:00)": "Matin (08:30–12:00)",
  "Middag (12:00–14:30)": "Midi (12:00–14:30)",
  "Namiddag (14:30–17:00 / 18:00 za)": "Après-midi (14:30–17:00 / 18:00 sam)",

  // --- Menu-analyse (menu engineering) ---
  "Menu-analyse": "Analyse du menu",
  "Elk gerecht op populariteit × prijs — wat koester je, wat verbeter je, wat schrap je?": "Chaque plat selon popularité × prix — que choyer, améliorer ou retirer ?",
  "Het menu in één beeld": "Le menu en un coup d'œil",
  "producten met minstens": "produits avec au moins",
  "verkochte stuks": "unités vendues",
  "drempels": "seuils",
  "stuks": "unités",
  "stuk": "unité",
  "Prijs per stuk is hier de marge-proxy (kostprijzen zitten niet in de kassadata). Rechtsboven = sterren, rechtsonder = werkpaarden, linksboven = puzzels, linksonder = honden.": "Le prix par unité sert ici de proxy de marge (les prix de revient ne sont pas dans les données de caisse). En haut à droite = stars, en bas à droite = chevaux de trait, en haut à gauche = énigmes, en bas à gauche = poids morts.",
  "Sterren": "Stars",
  "Werkpaarden": "Chevaux de trait",
  "Puzzels": "Énigmes",
  "Honden": "Poids morts",
  "Populair én hoge besteding — koesteren: prominent op de kaart, nooit schrappen.": "Populaire et dépense élevée — à choyer : bien en vue sur la carte, à ne jamais retirer.",
  "Veel verkocht, lagere prijs — het volume-fundament. Test voorzichtige prijsstappen of bundel met iets erbij.": "Très vendu, prix plus bas — la base du volume. Testez de petites hausses de prix ou une formule.",
  "Hoge besteding maar weinig verkocht — beter presenteren, aanbevelen of anders op de kaart zetten.": "Dépense élevée mais peu vendu — mieux présenter, recommander ou repositionner sur la carte.",
  "Weinig verkocht én lage besteding — kandidaten om te vervangen of te schrappen.": "Peu vendu et faible dépense — candidats au remplacement ou au retrait.",
  "en": "et",
  "andere": "autres",

  // --- Prognose (forecast card) ---
  "Prognose": "Prévision",
  "verwachte rest = gemiddelde per weekdag van de laatste 8 weken": "reste attendu = moyenne par jour de semaine des 8 dernières semaines",
  "afgesloten": "clôturé",
  "prognose": "prévision",
  "gerealiseerd": "réalisé",
  "nog": "encore",
  "prognose heel jaar": "prévision année complète",
  "vorig jaar": "l'an dernier",
  "in": "en",
  "groei": "croissance",
  "rest van het jaar = vorig jaar × deze groei": "reste de l'année = an dernier × cette croissance",

  // --- sweep 2026-08-25: Reports / Packaging / Data / Login ---
  "Handleiding": "Guide d’utilisation",
  "Hoe gebruik je het Perfy-platform — uitleg per onderdeel (in het Frans)": "Comment utiliser la plateforme Perfy — explications par section (en français)",
  "Bekijk de gids": "Voir le guide",
  "Data-analyse": "Analyse des données",
  "Gegenereerd op": "Généré le",
  "Nog niet gegenereerd": "Pas encore généré",
  "HTML nog niet beschikbaar.": "HTML pas encore disponible.",
  "PDF nog niet beschikbaar.": "PDF pas encore disponible.",
  "Nog geen rapporten gegenereerd.": "Aucun rapport généré pour l’instant.",
  "Deel via de knop \"Kopieer link\" of download de PDF.": "Partagez via le bouton « Copier le lien » ou téléchargez le PDF.",
  "Het rapport bevat bedrijfscijfers — deel het alleen met wie het mag zien.": "Le rapport contient des chiffres de l’entreprise — ne le partagez qu’avec les personnes autorisées.",
  "Deze beweging wissen?": "Supprimer ce mouvement ?",
  "Wissen mislukt.": "Échec de la suppression.",
  "Opslaan mislukt.": "Échec de l’enregistrement.",
  "Welke data zit in de rapportering, hoe vers is ze, en hier voeg je nieuwe LightSpeed-data toe.": "Quelles données alimentent les rapports, leur fraîcheur, et où ajouter de nouvelles données LightSpeed.",
  "kassa tot maart 2026": "caisse jusqu’en mars 2026",
  "kassa sinds maart 2026 — via API of upload hierboven": "caisse depuis mars 2026 — via l’API ou l’import ci-dessus",
  "Laatste LightSpeed-import": "Dernier import LightSpeed",
  "Laatste Odoo-sync": "Dernière synchro Odoo",
  "Café (alle consumpties)": "Café (toutes consommations)",
  "Winkel (niet-café)": "Boutique (hors café)",
  "Eten, dranken, ijs, extra’s en bouillons die in het café verkocht worden": "Plats, boissons, glaces, extras et bouillons vendus au café",
  "Lampen (LampTwist) en koffiebonen om mee te nemen": "Lampes (LampTwist) et café en grains à emporter",
  "Alles in de categorie Dranken (+ extra’s bij dranken)": "Tout ce qui est dans la catégorie Boissons (+ extras boissons)",
  "De categorie Voeding — alles wat eetbaar is": "La catégorie Alimentation — tout ce qui se mange",
  "De volledige categorie Ontbijt": "Toute la catégorie Petit-déjeuner",
  "Het product “Vegetable Plate” (groenteschotel)": "Le produit « Vegetable Plate » (assiette de légumes)",
  "Koffies op basis van espresso (ook dubbel, macchiato en iced)": "Cafés à base d’espresso (y compris double, macchiato et glacé)",
  "Matcha- en genmaicha-dranken (zonder Cookie Matcha)": "Boissons matcha et genmaicha (sans le Cookie Matcha)",
  "Zoetigheden, zonder de koekjes": "Douceurs, sans les biscuits",
  "De categorie IJs — bolletjes en coupes": "La catégorie Glaces — boules et coupes",
  "De subcategorie Koffie binnen Dranken": "La sous-catégorie Café dans Boissons",
  "De subcategorie Thee binnen Dranken": "La sous-catégorie Thé dans Boissons",
  "Koude dranken, thee en specials — dranken buiten koffie en matcha": "Boissons froides, thés et spéciaux — les boissons hors café et matcha",
  "Hartig eten buiten ontbijt, zoet en de Vegetable Plate": "Plats salés hors petit-déjeuner, douceurs et Vegetable Plate",
  "Inlogcode": "Code de connexion",

  // --- sweep 2026-08-25: Rapport / Menu / Relaties / Catalogus / Koppeling ---
  "Vorige": "Précédent",
  "Volgende": "Suivant",
  "omzet": "CA",
  "populair vanaf": "populaire à partir de",
  "hoge prijs vanaf": "prix élevé à partir de",
  "Rechtsboven = sterren (veel verkocht, hoge prijs) · rechtsonder = werkpaarden (veel verkocht, lagere prijs) · linksboven = puzzels (weinig verkocht, hoge prijs) · linksonder = honden (weinig verkocht, lage prijs).": "En haut à droite = stars (très vendu, prix élevé) · en bas à droite = chevaux de trait (très vendu, prix plus bas) · en haut à gauche = énigmes (peu vendu, prix élevé) · en bas à gauche = poids morts (peu vendu, prix bas).",
  "De horizontale as is samengedrukt, zodat kleine én grote verkopers leesbaar blijven.": "L’axe horizontal est comprimé pour que les petits et les grands vendeurs restent lisibles.",
  "Prijs per stuk geldt hier als schatting van de marge (kostprijzen zitten niet in de kassadata).": "Le prix par unité sert ici d’estimation de la marge (les prix de revient ne sont pas dans les données de caisse).",
  "Bol = product (grootte = hoe vaak verkocht) · lijn = samen gekocht (dikte = sterkte).": "Bulle = produit (taille = fréquence des ventes) · ligne = achetés ensemble (épaisseur = force).",
  "Tik op een bol om de relaties te zien.": "Touchez une bulle pour voir ses relations.",
  "Eten": "Nourriture",
  "Onbekend": "Inconnu",
  "Product uit de LightSpeed-kassa": "Produit de la caisse LightSpeed",
  "Product uit het oude systeem (Odoo)": "Produit de l’ancien système (Odoo)",
  "Sluiten": "Fermer",
  "(beheerder)": "(administrateur)",
  "Uit de kassa": "De la caisse",
  "Gebruikte categorie": "Catégorie utilisée",
  "Zelfde product in het oude systeem": "Même produit dans l’ancien système",
  "naam in het oude systeem…": "nom dans l’ancien système…",
  "Koppel": "Relier",
  "Geen overeenkomst gevonden": "Aucune correspondance trouvée",

  // --- sweep 2026-08-25: Overzicht / Drukte / Productgroepen / Kassabonnen / Samenstelling ---
  "Altijd het volledige jaar, los van de gekozen periode": "Toujours l’année complète, indépendamment de la période choisie",
  "Altijd de huidige maand en dit jaar, los van de gekozen periode": "Toujours le mois en cours et cette année, indépendamment de la période choisie",
  "Gekozen periode": "Période choisie",
  "gekozen periode": "période choisie",
  "zondag gesloten": "fermé le dimanche",
  "Gemiddelde bon per uur": "Ticket moyen par heure",
  "Bon per weekdag": "Ticket par jour de la semaine",
  "Het vaakst verkochte product per uur — het cijfer verwijst naar de legende onderaan": "Le produit le plus vendu par heure — le chiffre renvoie à la légende ci-dessous",
  "Kerstmis": "Noël",
  "Nieuwjaar": "Nouvel An",
  "Paasmaandag": "Lundi de Pâques",
  "Dag van de Arbeid": "Fête du Travail",
  "O.L.H. Hemelvaart": "Ascension",
  "Pinkstermaandag": "Lundi de Pentecôte",
  "Nationale feestdag": "Fête nationale",
  "O.L.V. Hemelvaart": "Assomption",
  "Allerheiligen": "Toussaint",
  "Wapenstilstand": "Armistice",
  "Verkoopontwikkeling per productgroep over de gekozen periode.": "Évolution des ventes par groupe de produits sur la période choisie.",
  "Jaar-op-jaar": "Année sur année",
  "Jaar-op-jaar vs dezelfde maanden vorig jaar · \"nieuw\" = stond toen nog niet op de kaart": "Année sur année vs les mêmes mois l’an dernier · « nouveau » = pas encore à la carte à l’époque",
  "vs de periode ervoor": "vs la période précédente",
  "vs de even lange periode ervoor": "vs la période précédente de même durée",
  "naamwissels gekoppeld": "changements de nom reliés",
  "'nieuw' = toen nog niet verkocht": "« nouveau » = pas encore vendu à l’époque",
  "De volledige categorie Food/Breakfast (ontbijtmenu)": "Toute la catégorie Food/Breakfast (menu petit-déjeuner)",
  "Zoet uit Food/Sweets, zonder de koekjes": "Les douceurs de Food/Sweets, sans les cookies",
  "Het product 'Vegetable Plate' (assiette de légumes)": "Le produit « Vegetable Plate » (assiette de légumes)",
  "De categorie Glaces — bolletjes, boules en coupes": "La catégorie Glaces — boules et coupes",
  "Alle cappuccino’s": "Tous les cappuccinos",
  "Koffies op basis van espresso (ook dubbel, macchiato, iced)": "Cafés à base d’espresso (aussi double, macchiato, glacé)",
  "De subcategorie Drinks/Coffee": "La sous-catégorie Drinks/Coffee",
  "Frisdranken, thee en specials — dranken buiten koffie en matcha": "Softs, thés et spéciaux — les boissons hors café et matcha",
  "De subcategorie Drinks/Tea": "La sous-catégorie Drinks/Tea",
  "Alles in de categorie Drinks (+ drank-extra’s)": "Tout ce qui est dans la catégorie Drinks (+ suppléments boissons)",
  "De categorie Food — alles wat eetbaar is": "La catégorie Food — tout ce qui se mange",
  "Geen betaalgegevens voor deze periode.": "Aucune donnée de paiement pour cette période.",
  "Een koffie": "Un café",
  "Een (ander) drankje": "Une (autre) boisson",
  "Iets te eten": "Quelque chose à manger",
  "Iets zoets (koek/gebak)": "Une douceur (cookie/pâtisserie)",
  "Cash": "Espèces",
  "Kaart": "Carte",
  "Artikelen (hoeveelheden) en verschillende producten zijn betrouwbaar; het aantal bonregels springt bij de overstap naar de nieuwe kassa (mrt 2026) door een andere manier van registreren, niet door ander koopgedrag": "Les articles (quantités) et les produits distincts sont fiables ; le nombre de lignes de ticket fait un saut au passage à la nouvelle caisse (mars 2026) à cause d’un autre mode d’enregistrement, pas d’un changement d’habitudes d’achat",
  "Te korte periode voor prijstrends — kies minstens 4 maanden.": "Période trop courte pour les tendances de prix — choisissez au moins 4 mois.",
  "Geen noemenswaardige stijgingen.": "Aucune hausse notable.",
  "(kaartprijs); zo tonen mix-effecten (gratis bolletjes, combo's) of kortingen zich niet als nep-prijswijziging.": "(prix à la carte) ; ainsi les effets de mix (boules offertes, combos) ou les remises n’apparaissent pas comme de faux changements de prix.",
  "De meest gebruikte korting is 50% — de personeelskorting. Pas sinds de nieuwe kassa (LightSpeed, mrt 2026) te volgen.": "La remise la plus utilisée est 50 % — la remise du personnel. Suivie seulement depuis la nouvelle caisse (LightSpeed, mars 2026).",
  "bonregels": "lignes de ticket",
  "kost voor het café": "coût pour le café",
  "komt overeen met de 50%-korting": "correspond à la remise de 50 %",
  "apart gehouden zodat de cijfers zuiver blijven. In de oude kassa werd korting nauwelijks geregistreerd.": "gardées à part pour que les chiffres restent propres. Dans l’ancienne caisse, les remises étaient à peine enregistrées.",
};
